import { jQuery } from './utils/jquery.js';

/**
 * @type {(function(*, *): *)|jQuery}
 * This file will contain custom woocommerce events and methods for the website.
 */
const jq = jQuery.noConflict(); // Manage No conflicts for
let shippingAlreadySet = false;

jQuery(function ($) {
  var cWooInstance = {
    checkoutFormEl: jq("form.checkout"),
    loadingText: "Please wait...",
    placeOrderBtnEl: jq("#place_order"),
    nextSvgIcon:
      '<svg class="button__arrow" width="20" height="11" viewBox="0 0 20 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.596 0.412248L19.8062 4.73327C20.0646 4.99843 20.0646 5.42833 19.8062 5.69349L15.596 10.0145C15.3376 10.2797 14.9187 10.2797 14.6604 10.0145C14.402 9.74935 14.402 9.31944 14.6604 9.05428L17.7412 5.89236H0V4.5344H17.7412L14.6604 1.37247C14.402 1.10732 14.402 0.677407 14.6604 0.412248C14.9187 0.147089 15.3376 0.147089 15.596 0.412248Z"></path></svg>',
    customCheckoutStepInputEl: jq("#wagt_custom_checkout_action"), // Checkout action to manage custom step action on the checkout
    shipToDifferentAddressHeadingEl: jq("#ship-to-different-address"),
    shipToDifferentAddressEl: jq("#ship-to-different-address-checkbox"), // ship to different address checkbox element
    stepPaymentMethodEl: jq(document).find(".js-woocommerce_checkout_payment"), // payment options wrapper
    stepShippingMethodEL: jq(document).find(".js-step-select-shipping"),
    stepBillingAddressEl: jq(document).find(".js-woocommerce_checkout_billing"),
    stepShippingAddressEl: jq(document).find(
      ".js-woocommerce_checkout_shipping"
    ),
    inputBoxTypes: "input, select, textarea",
    shippingLength: "shipping_".length,

    breadcrumbInformationEl: jq(".js-steps_nav-information"),
    breadcrumbShippingMethodEl: jq(".js-steps_nav-shipping-methods"),
    breadcrumbPaymentMethodEl: jq(".js-steps_nav-payment-methods"),

    // Manage page Breadcrumb:checkout page
    managePageTitle: function (step) {
      // Do hide all
      this.breadcrumbShippingMethodEl.hide();
      this.breadcrumbPaymentMethodEl.hide();
      this.breadcrumbInformationEl.hide();
      // Do hide all End
      // when step is information
      if (step === "information") {
        this.breadcrumbInformationEl.show();
      }
      // when step is shipping methods
      if (step === "step_shipping_methods") {
        this.breadcrumbShippingMethodEl.show();
      }
      // when step is payment methods
      if (step === "step_payment_methods") {
        this.breadcrumbPaymentMethodEl.show();
      }
      return true;
    },

    copyShippingAddressToBilling: function () {
      // Copy Shipping address to billing address
      jQuery(
        "input, select, textarea",
        ".woocommerce-shipping-fields__field-wrapper"
      ).each(function () {
        let field_id = jQuery(this).attr("id").substr("shipping_".length);
        jQuery("#billing_" + field_id).val(jQuery(this).val());
      });
    }, // update_order_review
    update_checkout: function (data) {
      console.log("update_checkout", data);
    },
    updated_checkout: function (event, data) {
      let is_request_failed = false;

      if(shippingAlreadySet) {
        jQuery('.review-shipping').show();
        jQuery('.review-no-shipping').hide();
      }

      if (data && "failure" === data.result) {
        is_request_failed = true;
      }
      // check step
      if (this.getCustomStepAction() === "step_shipping_address") {
        if (is_request_failed) {
          this.showStepShippingAddressForm();
        } else {
          this.showStepShippingMethodsForm();
        }
      }

      this.placeOrderBtnEl.find("svg").detach();
      this.placeOrderBtnEl.append(this.nextSvgIcon);

      this.preloaderOff();
    },
    emptyCustomStepAction: function () {
      this.customCheckoutStepInputEl.val("").trigger("change");
    },
    getCustomStepAction: function () {
      return this.customCheckoutStepInputEl.val();
    },
    setCustomStepAction: function (step) {
      if (typeof step === "undefined" || !step) {
        return;
      }
      this.customCheckoutStepInputEl.val(step).trigger("change");
    },
    isCheckout: function () {
      if (
        window.location.pathname === "/checkout/" ||
        window.location.pathname === "/checkout"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSelectedPaymentMethod: function () {
      return jQuery("input[name=payment_method]:checked").val();
    },
    changeOrderPlaceButtonText: function () {
      let selectedPg = this.getSelectedPaymentMethod();
      if (selectedPg === "cod") {
        this.placeOrderBtnEl.text(
          this.placeOrderBtnEl.attr("data-title-for-cod")
        );
      } else {
        this.placeOrderBtnEl.text(
          this.placeOrderBtnEl.attr("data-title-for-prepaid")
        );
      }
      this.placeOrderBtnEl.find("svg").detach();
      this.placeOrderBtnEl.append(this.nextSvgIcon);
    },
    scrollToEl: function (el) {
      if (typeof el == "undefined" || !el) {
        // el = "form.woocommerce-checkout";
        el = ".js-checkout-scroll-to";
      }
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(el).offset().top,
        },
        1000
      );
    },
    showStepShippingMethodsForm: function () {
      this.preloaderOff(); // Preloader off
      jQuery('.review-shipping').show();
      jQuery('.review-no-shipping').hide();
      shippingAlreadySet = true;
      this.stepPaymentMethodEl.hide(); // hide payment form
      this.stepShippingAddressEl.hide(); // hide shipping address form
      this.stepBillingAddressEl.hide(); // hide billing address form
      this.stepShippingMethodEL.show(); // show shipping methods
      this.scrollToEl();
      this.setCustomStepAction("step_shipping_methods");
      this.managePageTitle("step_shipping_methods");
    },
    showStepBillingAddressForm: function () {
      this.stepBillingAddressEl.show(); // show billing address form
    },
    hideStepBillingAddressForm: function () {
      this.stepBillingAddressEl.hide(); // show billing address form
    },
    showStepShippingAddressForm: function () {
      this.preloaderOff(); // Preloader off
      this.stepShippingMethodEL.hide(); // hide shipping methods
      this.stepPaymentMethodEl.hide(); // hide payment form
      this.stepBillingAddressEl.hide(); // show billing address form
      this.stepShippingAddressEl.show();
      this.emptyCustomStepAction();
      this.managePageTitle("information");
      this.scrollToEl();
    },
    showStepPaymentForm: function () {
      this.preloaderOff(); // Preloader off
      this.stepShippingMethodEL.hide(); // hide shipping methods
      this.stepPaymentMethodEl.show();
      jq(document).trigger("showStepPaymentForm");
      this.scrollToEl();
      this.setCustomStepAction("step_payment_methods");
      this.managePageTitle("step_payment_methods");
    },
    hideStepPaymentForm: function () {
      jq(document).trigger("hideStepPaymentForm");
    },
    isOrderReceivedPage: function () {
      if (window.location.href.indexOf("order-received") > -1) {
        return true;
      } else {
        return false;
      }
    },
    preloaderOn: function () {
      this.checkoutFormEl.addClass("processing").block({
        message: "Please wait..",
        overlayCSS: {
          background: "#fff",
          opacity: 0.6,
        },
      });
    },
    preloaderOff: function () {
      this.checkoutFormEl.removeClass("processing").unblock();
    }, // Preloader effect on Button when submitting
    buttonPreloaderShippingAddressForm: function (that) {
      this.preloaderOn();
    },
    setCustomValidity: function (inputEl, msg) {
      if (typeof msg === "undefined" || !msg) {
        msg = "This field is required.";
      }
      let input = document.querySelector(inputEl);
      let validityState = input.validity;
      if (validityState.valueMissing) {
        input.setCustomValidity(msg);
      } else {
        input.setCustomValidity("");
      }
      input.reportValidity();
    },
  };

  // Prevent checkout form submitting
  jQuery("form.checkout").on("checkout_place_order", function () {
    let selectedVal = jQuery(".js-billing-address-type:checked").val();
    if (typeof selectedVal === "undefined" || !selectedVal) {
      cWooInstance.setCustomValidity(".js-billing-address-type");
      return false;
    }
  });

  // Event on billing address type selected
  jQuery(document).on("click", ".js-billing-address-type", function () {
    let selectedVal = jQuery(".js-billing-address-type:checked").val();
    // different_billing_address | same_as_shipping_address
    if (selectedVal === "different_billing_address") {
      // show billing form
      cWooInstance.showStepBillingAddressForm();
    } else {
      cWooInstance.hideStepBillingAddressForm(); // hide billing address form
      // copy shipping details into billing details
      cWooInstance.copyShippingAddressToBilling();
    }
  });

  // keep in sync with billing
  jQuery(
    "input, select, textarea",
    ".woocommerce-shipping-fields__field-wrapper"
  ).on("change keyup update", function () {
    cWooInstance.copyShippingAddressToBilling();
  });

  // button event continue to payment form
  jQuery(document).on("click", ".js-step-continue-to-payment", function () {
    cWooInstance.showStepPaymentForm();
  });

  // Button event continue to select shipping form
  jQuery(document).on(
    "click",
    ".js-step-continue-to-select-shipping",
    function () {
      cWooInstance.buttonPreloaderShippingAddressForm(this); // Button text affect
      if (cWooInstance.getCustomStepAction() === "step_payment_methods") {
        // this mean coming from another button
        cWooInstance.showStepShippingMethodsForm();
      } else {
        cWooInstance.setCustomStepAction("step_shipping_address");
        jQuery("body").trigger("update_checkout", {
          custom_checkout_action: "validate_shipping_address",
        });
      }
    }
  );

  // On Payment method change
  jQuery(document).on(
    "change checked selected",
    "input[name=payment_method]",
    function () {
      cWooInstance.changeOrderPlaceButtonText();
    }
  );

  // Show Shipping address form details
  jQuery(document).on(
    "click",
    ".js-step-shipping-address-details",
    function () {
      cWooInstance.showStepShippingAddressForm();
    }
  );

  // Manage update checkout event after order review ajax
  jQuery(document.body).on("updated_checkout", function (event, data) {
    cWooInstance.updated_checkout(event, data);
  });

  // On Change payment method
  jQuery(document.body).on("payment_method_selected", function () {
    cWooInstance.placeOrderBtnEl.find("svg").detach();
    cWooInstance.placeOrderBtnEl.append(cWooInstance.nextSvgIcon);
  });

  // show shipping method form default
  if (cWooInstance.isCheckout()) {
    cWooInstance.showStepShippingAddressForm();
    cWooInstance.shipToDifferentAddressHeadingEl.hide(); // hide ship to different address heading wrap
    // Manage Place order button text
    cWooInstance.changeOrderPlaceButtonText();

    // on init make empty custom checkout action because this may cause errors for certain condition
    cWooInstance.emptyCustomStepAction();

    // Prevent key
    jQuery(window).keydown(function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        return false;
      }
    });
  }
});
